module.exports = __webpack_public_path__ + "assets/img/32_628_big.5ec4b07a.jpg";